import React from "react";
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from "react-router-dom";
import "./App.css";
import KinKeeperLanding from "./components/kinkeeperLanding";
import KinKeeperLogin from "./components/relativeLogin";
import KinKeeperRegister from "./components/memberRegister";
import CreateElderProfile from "./components/createElderProfile";
import ElderProfileView from "./components/elderProfileViewer";
import ElderListPage from "./components/elderListPage";
import ProtectedRoute from "./components/protected";
import Logout from "./components/logout";
import LanguageSwitcher from "./components/LanguageSwitcher";
import UberCareKinKeepersPage from "./components/UberCareKinKeepersPage";
import logo from "./images/cape.png";

const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  UBERCARE_INFO: "/ubercare-for-kinkeepers",
  ELDERS: "/elders",
  ELDER_NEW: "/elders/new",
  ELDER_PROFILE: "/elders/profile"
};

const AppContent = () => {
  const location = useLocation();
  const isStandaloneUberCarePage = location.pathname === ROUTES.UBERCARE_INFO;

  return (
    <div className="app-shell">
      {!isStandaloneUberCarePage ? (
        <header className="topbar">
          <Link to={ROUTES.HOME} className="topbar-brand">
            <img src={logo} alt="UberCARE for Kin-keepers" className="topbar-logo" />
            <span className="topbar-title">UberCARE for Kin-keepers</span>
          </Link>

          <nav className="topbar-links" aria-label="Primary navigation">
            <Link className="nav-link" to={ROUTES.HOME}>
              Home
            </Link>
            <Link className="nav-link" to={ROUTES.LOGIN}>
              Login
            </Link>
            <Link className="nav-link" to={ROUTES.REGISTER}>
              Register
            </Link>
            <Logout />
            <LanguageSwitcher />
          </nav>
        </header>
      ) : null}

      <main className={isStandaloneUberCarePage ? "page-offset page-offset-standalone" : "page-offset"}>
        <Routes>
          <Route path={ROUTES.HOME} element={<KinKeeperLanding />} />
          <Route path={ROUTES.UBERCARE_INFO} element={<UberCareKinKeepersPage />} />
          <Route path={ROUTES.LOGIN} element={<KinKeeperLogin />} />
          <Route path={ROUTES.REGISTER} element={<KinKeeperRegister />} />
          <Route path="/logout" element={<Logout />} />
          <Route
            path={ROUTES.ELDER_NEW}
            element={
              <ProtectedRoute>
                <CreateElderProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.ELDER_PROFILE}
            element={
              <ProtectedRoute>
                <ElderProfileView />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.ELDERS}
            element={
              <ProtectedRoute>
                <ElderListPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
    </div>
  );
};

const App = () => {
  return (
    <Router basename="/kinkeeper">
      <AppContent />
    </Router>
  );
};

export default App;
